import React from 'react';
import styles from './PackageCard.module.scss';

import CheckmarkIcon from '../../../assets/icons/Checkmark.svg';

const PackageCard = ({
  title,
  price,
  services,
  description,
  isRecommended,
  isSelected,
  onSelect,
  onShowComparison,
}) => {
  const cardClasses = `
    ${styles.card}
    ${isSelected ? styles.selected : ''}
    ${isRecommended ? styles.recommended : ''}
  `;

  return (
    <div className={cardClasses} onClick={onSelect}>
      {isRecommended && (
        <div className={styles.recommendedWrapper}>
          <div className={styles.recommendedBadge}>Рекомендуємо</div>
          <svg width="144" height="67" viewBox="0 0 144 67" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M144 67H142V51C142 42.1634 134.837 35 126 35H36C27.1634 35 20 27.8366 20 19V18C20 9.16345 12.8365 2.00001 4 2H0V0H144V67Z" fill="url(#paint0_linear_packagecard)"/>
            <defs>
              <linearGradient id="paint0_linear_packagecard" x1="2.51895" y1="2.0446" x2="119.129" y2="97.4115" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FC5413"/>
                <stop offset="1" stopColor="#ED3A09"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
      )}
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.price}>{price}</p>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      <div className={styles.divider}></div>
      <div className={styles.services}>
        {services.map((service, index) => (
          <div key={index} className={styles.serviceItem}>
            <img src={CheckmarkIcon} alt="checkmark" />
            <span>{service}</span>
          </div>
        ))}
      </div>
      <div className={styles.footer}>
        <button className={styles.compareLink} onClick={onShowComparison}>
          Показати порівняння і вигоди
        </button>
        
      </div>
    </div>
  );
};

export default PackageCard;
